import fetch from "unfetch";
import * as Sentry from "@sentry/browser";

export const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
};

const fetcher = (url, options, data) => {
  let init = {
    method: METHODS.GET,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  if (options && (typeof options === "string" || options instanceof String)) {
    init.method = options;
  } else if (options) {
    init = {
      method: options.method || init.method,
      headers: {
        ...init.headers,
        ...options.headers,
      },
    };
  }

  if (
    (init.method && init.method === METHODS.POST) ||
    init.method === METHODS.PUT
  ) {
    init.body = JSON.stringify(data);
  }

  try {
    return fetch(url, init).then((r) => {
      if (r.ok && (r.status === 200 || r.status === 201)) {
        return r.json();
      } else if (r.ok && r.status === 204) {
        return;
      } else if (r.status === 429) {
        Sentry.setExtra("submittedData", data);
        Sentry.captureException(new Error("You've tried that too many times"));
        throw new Error("You've tried that too many times");
      } else {
        // throw new Error(r.statusText);
        console.error(r.statusText);
        Sentry.setExtra("submittedData", data);
        return;
      }
    });
  } catch (err) {
    console.error(err);
    Sentry.setExtra("submittedData", data);
    return;
  }
};

export default fetcher;
